import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1235cd60 = () => interopDefault(import('..\\pages\\appbh.vue' /* webpackChunkName: "pages/appbh" */))
const _bc85a452 = () => interopDefault(import('..\\pages\\error\\404.vue' /* webpackChunkName: "pages/error/404" */))
const _c6d75306 = () => interopDefault(import('..\\pages\\error\\pay-success.vue' /* webpackChunkName: "pages/error/pay-success" */))
const _1bf71f75 = () => interopDefault(import('..\\pages\\jiantou\\claim.vue' /* webpackChunkName: "pages/jiantou/claim" */))
const _ef2176e6 = () => interopDefault(import('..\\pages\\web\\bhquery\\index.vue' /* webpackChunkName: "pages/web/bhquery/index" */))
const _64105d60 = () => interopDefault(import('..\\pages\\web\\ggzybh\\index.vue' /* webpackChunkName: "pages/web/ggzybh/index" */))
const _ae0f3fec = () => interopDefault(import('..\\pages\\web\\online-service\\index.vue' /* webpackChunkName: "pages/web/online-service/index" */))
const _db4a8ac0 = () => interopDefault(import('..\\pages\\web\\register.vue' /* webpackChunkName: "pages/web/register" */))
const _56c91e35 = () => interopDefault(import('..\\pages\\web\\zbdl\\index.vue' /* webpackChunkName: "pages/web/zbdl/index" */))
const _a55ec0ec = () => interopDefault(import('..\\pages\\branch\\bhtong\\aboutus\\index.vue' /* webpackChunkName: "pages/branch/bhtong/aboutus/index" */))
const _9e871e84 = () => interopDefault(import('..\\pages\\branch\\bhtong\\bh-query\\index.vue' /* webpackChunkName: "pages/branch/bhtong/bh-query/index" */))
const _55f8b73b = () => interopDefault(import('..\\pages\\branch\\bhtong\\finance\\index.vue' /* webpackChunkName: "pages/branch/bhtong/finance/index" */))
const _0b00ba58 = () => interopDefault(import('..\\pages\\branch\\bhtong\\help-center\\index.vue' /* webpackChunkName: "pages/branch/bhtong/help-center/index" */))
const _76c13203 = () => interopDefault(import('..\\pages\\branch\\bhtong\\index\\index.vue' /* webpackChunkName: "pages/branch/bhtong/index/index" */))
const _487ee2b7 = () => interopDefault(import('..\\pages\\branch\\bhtong\\joinpartner\\index.vue' /* webpackChunkName: "pages/branch/bhtong/joinpartner/index" */))
const _9a7b378a = () => interopDefault(import('..\\pages\\branch\\common\\aboutus\\index.vue' /* webpackChunkName: "pages/branch/common/aboutus/index" */))
const _4f591e22 = () => interopDefault(import('..\\pages\\branch\\fybh\\index\\index.vue' /* webpackChunkName: "pages/branch/fybh/index/index" */))
const _5d197f99 = () => interopDefault(import('..\\pages\\branch\\mancheng\\bh-query\\index.vue' /* webpackChunkName: "pages/branch/mancheng/bh-query/index" */))
const _48830908 = () => interopDefault(import('..\\pages\\branch\\mancheng\\index\\index.vue' /* webpackChunkName: "pages/branch/mancheng/index/index" */))
const _c2ab46ee = () => interopDefault(import('..\\pages\\branch\\yfh\\aboutus\\index.vue' /* webpackChunkName: "pages/branch/yfh/aboutus/index" */))
const _2acb58c2 = () => interopDefault(import('..\\pages\\branch\\yfh\\bh-query\\index.vue' /* webpackChunkName: "pages/branch/yfh/bh-query/index" */))
const _4752743a = () => interopDefault(import('..\\pages\\branch\\yfh\\finance\\index.vue' /* webpackChunkName: "pages/branch/yfh/finance/index" */))
const _02b66f5a = () => interopDefault(import('..\\pages\\branch\\yfh\\help-center\\index.vue' /* webpackChunkName: "pages/branch/yfh/help-center/index" */))
const _9dd7ba7c = () => interopDefault(import('..\\pages\\branch\\yfh\\index\\index.vue' /* webpackChunkName: "pages/branch/yfh/index/index" */))
const _0613e168 = () => interopDefault(import('..\\pages\\branch\\yfh\\inspection\\index.vue' /* webpackChunkName: "pages/branch/yfh/inspection/index" */))
const _4ca40836 = () => interopDefault(import('..\\pages\\branch\\yfh\\joinpartner\\index.vue' /* webpackChunkName: "pages/branch/yfh/joinpartner/index" */))
const _7b4bb06a = () => interopDefault(import('..\\pages\\branch\\yfh\\login\\index.vue' /* webpackChunkName: "pages/branch/yfh/login/index" */))
const _33c31ec6 = () => interopDefault(import('..\\pages\\branch\\yfh\\order\\index.vue' /* webpackChunkName: "pages/branch/yfh/order/index" */))
const _009f922e = () => interopDefault(import('..\\pages\\branch\\ysbh\\index\\index.vue' /* webpackChunkName: "pages/branch/ysbh/index/index" */))
const _bce45be2 = () => interopDefault(import('..\\pages\\branch\\zceb\\index\\index.vue' /* webpackChunkName: "pages/branch/zceb/index/index" */))
const _7d611256 = () => interopDefault(import('..\\pages\\sys\\all\\all.vue' /* webpackChunkName: "pages/sys/all/all" */))
const _7d3ba320 = () => interopDefault(import('..\\pages\\sys\\applybh\\paybh.vue' /* webpackChunkName: "pages/sys/applybh/paybh" */))
const _16aba5a1 = () => interopDefault(import('..\\pages\\sys\\applybh\\payend.vue' /* webpackChunkName: "pages/sys/applybh/payend" */))
const _78a829e6 = () => interopDefault(import('..\\pages\\sys\\bhcheck\\detail.vue' /* webpackChunkName: "pages/sys/bhcheck/detail" */))
const _0ae16dda = () => interopDefault(import('..\\pages\\sys\\bhcheck\\list.vue' /* webpackChunkName: "pages/sys/bhcheck/list" */))
const _31c6f1a1 = () => interopDefault(import('..\\pages\\sys\\bhcheck\\print.vue' /* webpackChunkName: "pages/sys/bhcheck/print" */))
const _33ca14a5 = () => interopDefault(import('..\\pages\\sys\\coupons\\list.vue' /* webpackChunkName: "pages/sys/coupons/list" */))
const _570142db = () => interopDefault(import('..\\pages\\sys\\filecustomerdwmg\\list.vue' /* webpackChunkName: "pages/sys/filecustomerdwmg/list" */))
const _3ee5f211 = () => interopDefault(import('..\\pages\\sys\\ggzy\\bh-auto\\index.vue' /* webpackChunkName: "pages/sys/ggzy/bh-auto/index" */))
const _dee0a362 = () => interopDefault(import('..\\pages\\sys\\mailaddressmg\\list.vue' /* webpackChunkName: "pages/sys/mailaddressmg/list" */))
const _1d06a186 = () => interopDefault(import('..\\pages\\sys\\ordermg\\bh-detail.vue' /* webpackChunkName: "pages/sys/ordermg/bh-detail" */))
const _4a83c142 = () => interopDefault(import('..\\pages\\sys\\ordermg\\list\\index.vue' /* webpackChunkName: "pages/sys/ordermg/list/index" */))
const _5697c1fc = () => interopDefault(import('..\\pages\\sys\\ordermg\\list-usertype-1\\index.vue' /* webpackChunkName: "pages/sys/ordermg/list-usertype-1/index" */))
const _33aa1958 = () => interopDefault(import('..\\pages\\sys\\receiptinfomg\\list.vue' /* webpackChunkName: "pages/sys/receiptinfomg/list" */))
const _371f1f8d = () => interopDefault(import('..\\pages\\sys\\userinfo\\list.vue' /* webpackChunkName: "pages/sys/userinfo/list" */))
const _b1500ab0 = () => interopDefault(import('..\\pages\\sys\\zb-notice\\detail.vue' /* webpackChunkName: "pages/sys/zb-notice/detail" */))
const _6df2a835 = () => interopDefault(import('..\\pages\\sys\\zb-notice\\list.vue' /* webpackChunkName: "pages/sys/zb-notice/list" */))
const _2911269d = () => interopDefault(import('..\\pages\\web\\all\\all.vue' /* webpackChunkName: "pages/web/all/all" */))
const _64567514 = () => interopDefault(import('..\\pages\\web\\query\\main.vue' /* webpackChunkName: "pages/web/query/main" */))
const _c6bc22e8 = () => interopDefault(import('..\\pages\\branch\\bhtong\\bh-query\\res.vue' /* webpackChunkName: "pages/branch/bhtong/bh-query/res" */))
const _55e31132 = () => interopDefault(import('..\\pages\\branch\\bhtong\\news\\detail.vue' /* webpackChunkName: "pages/branch/bhtong/news/detail" */))
const _705de187 = () => interopDefault(import('..\\pages\\branch\\bhtong\\news\\newslist.vue' /* webpackChunkName: "pages/branch/bhtong/news/newslist" */))
const _a6a5d4a6 = () => interopDefault(import('..\\pages\\branch\\yfh\\bh-query\\res.vue' /* webpackChunkName: "pages/branch/yfh/bh-query/res" */))
const _7d35d77c = () => interopDefault(import('..\\pages\\branch\\yfh\\inspection\\query.vue' /* webpackChunkName: "pages/branch/yfh/inspection/query" */))
const _0f616826 = () => interopDefault(import('..\\pages\\branch\\yfh\\news\\detail.vue' /* webpackChunkName: "pages/branch/yfh/news/detail" */))
const _61b79e86 = () => interopDefault(import('..\\pages\\branch\\yfh\\news\\newslist.vue' /* webpackChunkName: "pages/branch/yfh/news/newslist" */))
const _71f7b3a1 = () => interopDefault(import('..\\pages\\branch\\yfh\\order\\account.vue' /* webpackChunkName: "pages/branch/yfh/order/account" */))
const _46186ce6 = () => interopDefault(import('..\\pages\\branch\\yfh\\order\\detail.vue' /* webpackChunkName: "pages/branch/yfh/order/detail" */))
const _34d47500 = () => interopDefault(import('..\\pages\\branch\\yfh\\order\\form.vue' /* webpackChunkName: "pages/branch/yfh/order/form" */))
const _7527729d = () => interopDefault(import('..\\pages\\branch\\yfh\\order\\invoiceapply.vue' /* webpackChunkName: "pages/branch/yfh/order/invoiceapply" */))
const _2163ec9c = () => interopDefault(import('..\\pages\\branch\\yfh\\order\\invoicedetail.vue' /* webpackChunkName: "pages/branch/yfh/order/invoicedetail" */))
const _6e4d8816 = () => interopDefault(import('..\\pages\\branch\\yfh\\order\\main.vue' /* webpackChunkName: "pages/branch/yfh/order/main" */))
const _3af2720c = () => interopDefault(import('..\\pages\\branch\\yfh\\order\\payment.vue' /* webpackChunkName: "pages/branch/yfh/order/payment" */))
const _4c1dc805 = () => interopDefault(import('..\\pages\\branch\\yfh\\order\\refunddetail.vue' /* webpackChunkName: "pages/branch/yfh/order/refunddetail" */))
const _abd87bc0 = () => interopDefault(import('..\\pages\\branch\\yfh\\order\\xzchjg.vue' /* webpackChunkName: "pages/branch/yfh/order/xzchjg" */))
const _7a18a4be = () => interopDefault(import('..\\pages\\sys\\ggzy\\virtual-money-acc\\detail.vue' /* webpackChunkName: "pages/sys/ggzy/virtual-money-acc/detail" */))
const _083a406a = () => interopDefault(import('..\\pages\\sys\\ggzy\\virtual-money-acc\\list.vue' /* webpackChunkName: "pages/sys/ggzy/virtual-money-acc/list" */))
const _9785ed66 = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-file\\detail.vue' /* webpackChunkName: "pages/sys/ggzy/zb-file/detail" */))
const _c4b5c7cc = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-file\\list.vue' /* webpackChunkName: "pages/sys/ggzy/zb-file/list" */))
const _6601b2ae = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-notice\\detail.vue' /* webpackChunkName: "pages/sys/ggzy/zb-notice/detail" */))
const _f8648cc8 = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-notice\\form.vue' /* webpackChunkName: "pages/sys/ggzy/zb-notice/form" */))
const _4027571e = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-notice\\form-fast-add.vue' /* webpackChunkName: "pages/sys/ggzy/zb-notice/form-fast-add" */))
const _90723f14 = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-notice\\list.vue' /* webpackChunkName: "pages/sys/ggzy/zb-notice/list" */))
const _5617a18a = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-pro\\list.vue' /* webpackChunkName: "pages/sys/ggzy/zb-pro/list" */))
const _53f654c4 = () => interopDefault(import('..\\pages\\sys\\ggzy\\zb-pro\\list-bd.vue' /* webpackChunkName: "pages/sys/ggzy/zb-pro/list-bd" */))
const _191bbdaf = () => interopDefault(import('..\\pages\\sys\\guarantee\\hanhua\\hhly-apply.vue' /* webpackChunkName: "pages/sys/guarantee/hanhua/hhly-apply" */))
const _437cd2de = () => interopDefault(import('..\\pages\\web\\guarantee\\hanhua\\form.vue' /* webpackChunkName: "pages/web/guarantee/hanhua/form" */))
const _5d16ebc8 = () => interopDefault(import('..\\pages\\web\\guarantee\\hanhua\\hhly-apply.vue' /* webpackChunkName: "pages/web/guarantee/hanhua/hhly-apply" */))
const _2e3b4cba = () => interopDefault(import('..\\pages\\web\\guarantee\\huanghe\\form.vue' /* webpackChunkName: "pages/web/guarantee/huanghe/form" */))
const _8c8cc4a4 = () => interopDefault(import('..\\pages\\web\\guarantee\\tianan\\form.vue' /* webpackChunkName: "pages/web/guarantee/tianan/form" */))
const _d5012c78 = () => interopDefault(import('..\\pages\\web\\guarantee\\yangguang\\form.vue' /* webpackChunkName: "pages/web/guarantee/yangguang/form" */))
const _065557ce = () => interopDefault(import('..\\pages\\web\\guarantee\\zhonghua\\form-xm.vue' /* webpackChunkName: "pages/web/guarantee/zhonghua/form-xm" */))
const _2cc02207 = () => interopDefault(import('..\\pages\\branch\\bhtong\\aboutus\\sectioins\\company-introduction.vue' /* webpackChunkName: "pages/branch/bhtong/aboutus/sectioins/company-introduction" */))
const _bc628132 = () => interopDefault(import('..\\pages\\branch\\bhtong\\aboutus\\sectioins\\platform-introduction.vue' /* webpackChunkName: "pages/branch/bhtong/aboutus/sectioins/platform-introduction" */))
const _38074a01 = () => interopDefault(import('..\\pages\\branch\\bhtong\\aboutus\\sectioins\\statistic-box.vue' /* webpackChunkName: "pages/branch/bhtong/aboutus/sectioins/statistic-box" */))
const _569b8e8b = () => interopDefault(import('..\\pages\\web\\guarantee\\tianan\\text\\text.js' /* webpackChunkName: "pages/web/guarantee/tianan/text/text" */))
const _547b727b = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _726bf2bf = () => interopDefault(import('..\\pages\\error\\404' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/appbh",
    component: _1235cd60,
    alias: ["/appbh/index.html","/appbh.html"],
    name: "appbh"
  }, {
    path: "/error/404",
    component: _bc85a452,
    alias: ["/error/404/index.html","/error/404.html"],
    name: "error-404"
  }, {
    path: "/error/pay-success",
    component: _c6d75306,
    alias: ["/error/pay-success/index.html","/error/pay-success.html"],
    name: "error-pay-success"
  }, {
    path: "/jiantou/claim",
    component: _1bf71f75,
    alias: ["/jiantou/claim/index.html","/jiantou/claim.html"],
    name: "jiantou-claim"
  }, {
    path: "/web/bhquery",
    component: _ef2176e6,
    alias: ["/web/bhquery/index.html","/web/bhquery.html"],
    name: "web-bhquery"
  }, {
    path: "/web/ggzybh",
    component: _64105d60,
    alias: ["/web/ggzybh/index.html","/web/ggzybh.html"],
    name: "web-ggzybh"
  }, {
    path: "/web/online-service",
    component: _ae0f3fec,
    alias: ["/web/online-service/index.html","/web/online-service.html"],
    name: "web-online-service"
  }, {
    path: "/web/register",
    component: _db4a8ac0,
    alias: ["/web/register/index.html","/web/register.html"],
    name: "web-register"
  }, {
    path: "/web/zbdl",
    component: _56c91e35,
    alias: ["/web/zbdl/index.html","/web/zbdl.html"],
    name: "web-zbdl"
  }, {
    path: "/branch/bhtong/aboutus",
    component: _a55ec0ec,
    alias: ["/branch/bhtong/aboutus/index.html","/branch/bhtong/aboutus.html"],
    name: "branch-bhtong-aboutus"
  }, {
    path: "/branch/bhtong/bh-query",
    component: _9e871e84,
    alias: ["/branch/bhtong/bh-query/index.html","/branch/bhtong/bh-query.html"],
    name: "branch-bhtong-bh-query"
  }, {
    path: "/branch/bhtong/finance",
    component: _55f8b73b,
    alias: ["/branch/bhtong/finance/index.html","/branch/bhtong/finance.html"],
    name: "branch-bhtong-finance"
  }, {
    path: "/branch/bhtong/help-center",
    component: _0b00ba58,
    alias: ["/branch/bhtong/help-center/index.html","/branch/bhtong/help-center.html"],
    name: "branch-bhtong-help-center"
  }, {
    path: "/branch/bhtong/index",
    component: _76c13203,
    alias: ["/branch/bhtong/index/index.html","/branch/bhtong/index.html"],
    name: "branch-bhtong-index"
  }, {
    path: "/branch/bhtong/joinpartner",
    component: _487ee2b7,
    alias: ["/branch/bhtong/joinpartner/index.html","/branch/bhtong/joinpartner.html"],
    name: "branch-bhtong-joinpartner"
  }, {
    path: "/branch/common/aboutus",
    component: _9a7b378a,
    alias: ["/branch/common/aboutus/index.html","/branch/common/aboutus.html"],
    name: "branch-common-aboutus"
  }, {
    path: "/branch/fybh/index",
    component: _4f591e22,
    alias: ["/branch/fybh/index/index.html","/branch/fybh/index.html"],
    name: "branch-fybh-index"
  }, {
    path: "/branch/mancheng/bh-query",
    component: _5d197f99,
    alias: ["/branch/mancheng/bh-query/index.html","/branch/mancheng/bh-query.html"],
    name: "branch-mancheng-bh-query"
  }, {
    path: "/branch/mancheng/index",
    component: _48830908,
    alias: ["/branch/mancheng/index/index.html","/branch/mancheng/index.html"],
    name: "branch-mancheng-index"
  }, {
    path: "/branch/yfh/aboutus",
    component: _c2ab46ee,
    alias: ["/branch/yfh/aboutus/index.html","/branch/yfh/aboutus.html"],
    name: "branch-yfh-aboutus"
  }, {
    path: "/branch/yfh/bh-query",
    component: _2acb58c2,
    alias: ["/branch/yfh/bh-query/index.html","/branch/yfh/bh-query.html"],
    name: "branch-yfh-bh-query"
  }, {
    path: "/branch/yfh/finance",
    component: _4752743a,
    alias: ["/branch/yfh/finance/index.html","/branch/yfh/finance.html"],
    name: "branch-yfh-finance"
  }, {
    path: "/branch/yfh/help-center",
    component: _02b66f5a,
    alias: ["/branch/yfh/help-center/index.html","/branch/yfh/help-center.html"],
    name: "branch-yfh-help-center"
  }, {
    path: "/branch/yfh/index",
    component: _9dd7ba7c,
    alias: ["/branch/yfh/index/index.html","/branch/yfh/index.html"],
    name: "branch-yfh-index"
  }, {
    path: "/branch/yfh/inspection",
    component: _0613e168,
    alias: ["/branch/yfh/inspection/index.html","/branch/yfh/inspection.html"],
    name: "branch-yfh-inspection"
  }, {
    path: "/branch/yfh/joinpartner",
    component: _4ca40836,
    alias: ["/branch/yfh/joinpartner/index.html","/branch/yfh/joinpartner.html"],
    name: "branch-yfh-joinpartner"
  }, {
    path: "/branch/yfh/login",
    component: _7b4bb06a,
    alias: ["/branch/yfh/login/index.html","/branch/yfh/login.html"],
    name: "branch-yfh-login"
  }, {
    path: "/branch/yfh/order",
    component: _33c31ec6,
    alias: ["/branch/yfh/order/index.html","/branch/yfh/order.html"],
    name: "branch-yfh-order"
  }, {
    path: "/branch/ysbh/index",
    component: _009f922e,
    alias: ["/branch/ysbh/index/index.html","/branch/ysbh/index.html"],
    name: "branch-ysbh-index"
  }, {
    path: "/branch/zceb/index",
    component: _bce45be2,
    alias: ["/branch/zceb/index/index.html","/branch/zceb/index.html"],
    name: "branch-zceb-index"
  }, {
    path: "/sys/all/all",
    component: _7d611256,
    alias: ["/sys/all/all/index.html","/sys/all/all.html"],
    name: "sys-all-all"
  }, {
    path: "/sys/applybh/paybh",
    component: _7d3ba320,
    alias: ["/sys/applybh/paybh/index.html","/sys/applybh/paybh.html"],
    name: "sys-applybh-paybh"
  }, {
    path: "/sys/applybh/payend",
    component: _16aba5a1,
    alias: ["/sys/applybh/payend/index.html","/sys/applybh/payend.html"],
    name: "sys-applybh-payend"
  }, {
    path: "/sys/bhcheck/detail",
    component: _78a829e6,
    alias: ["/sys/bhcheck/detail/index.html","/sys/bhcheck/detail.html"],
    name: "sys-bhcheck-detail"
  }, {
    path: "/sys/bhcheck/list",
    component: _0ae16dda,
    alias: ["/sys/bhcheck/list/index.html","/sys/bhcheck/list.html"],
    name: "sys-bhcheck-list"
  }, {
    path: "/sys/bhcheck/print",
    component: _31c6f1a1,
    alias: ["/sys/bhcheck/print/index.html","/sys/bhcheck/print.html"],
    name: "sys-bhcheck-print"
  }, {
    path: "/sys/coupons/list",
    component: _33ca14a5,
    alias: ["/sys/coupons/list/index.html","/sys/coupons/list.html"],
    name: "sys-coupons-list"
  }, {
    path: "/sys/filecustomerdwmg/list",
    component: _570142db,
    alias: ["/sys/filecustomerdwmg/list/index.html","/sys/filecustomerdwmg/list.html"],
    name: "sys-filecustomerdwmg-list"
  }, {
    path: "/sys/ggzy/bh-auto",
    component: _3ee5f211,
    alias: ["/sys/ggzy/bh-auto/index.html","/sys/ggzy/bh-auto.html"],
    name: "sys-ggzy-bh-auto"
  }, {
    path: "/sys/mailaddressmg/list",
    component: _dee0a362,
    alias: ["/sys/mailaddressmg/list/index.html","/sys/mailaddressmg/list.html"],
    name: "sys-mailaddressmg-list"
  }, {
    path: "/sys/ordermg/bh-detail",
    component: _1d06a186,
    alias: ["/sys/ordermg/bh-detail/index.html","/sys/ordermg/bh-detail.html"],
    name: "sys-ordermg-bh-detail"
  }, {
    path: "/sys/ordermg/list",
    component: _4a83c142,
    alias: ["/sys/ordermg/list/index.html","/sys/ordermg/list.html"],
    name: "sys-ordermg-list"
  }, {
    path: "/sys/ordermg/list-usertype-1",
    component: _5697c1fc,
    alias: ["/sys/ordermg/list-usertype-1/index.html","/sys/ordermg/list-usertype-1.html"],
    name: "sys-ordermg-list-usertype-1"
  }, {
    path: "/sys/receiptinfomg/list",
    component: _33aa1958,
    alias: ["/sys/receiptinfomg/list/index.html","/sys/receiptinfomg/list.html"],
    name: "sys-receiptinfomg-list"
  }, {
    path: "/sys/userinfo/list",
    component: _371f1f8d,
    alias: ["/sys/userinfo/list/index.html","/sys/userinfo/list.html"],
    name: "sys-userinfo-list"
  }, {
    path: "/sys/zb-notice/detail",
    component: _b1500ab0,
    alias: ["/sys/zb-notice/detail/index.html","/sys/zb-notice/detail.html"],
    name: "sys-zb-notice-detail"
  }, {
    path: "/sys/zb-notice/list",
    component: _6df2a835,
    alias: ["/sys/zb-notice/list/index.html","/sys/zb-notice/list.html"],
    name: "sys-zb-notice-list"
  }, {
    path: "/web/all/all",
    component: _2911269d,
    alias: ["/web/all/all/index.html","/web/all/all.html"],
    name: "web-all-all"
  }, {
    path: "/web/query/main",
    component: _64567514,
    alias: ["/web/query/main/index.html","/web/query/main.html"],
    name: "web-query-main"
  }, {
    path: "/branch/bhtong/bh-query/res",
    component: _c6bc22e8,
    alias: ["/branch/bhtong/bh-query/res/index.html","/branch/bhtong/bh-query/res.html"],
    name: "branch-bhtong-bh-query-res"
  }, {
    path: "/branch/bhtong/news/detail",
    component: _55e31132,
    alias: ["/branch/bhtong/news/detail/index.html","/branch/bhtong/news/detail.html"],
    name: "branch-bhtong-news-detail"
  }, {
    path: "/branch/bhtong/news/newslist",
    component: _705de187,
    alias: ["/branch/bhtong/news/newslist/index.html","/branch/bhtong/news/newslist.html"],
    name: "branch-bhtong-news-newslist"
  }, {
    path: "/branch/yfh/bh-query/res",
    component: _a6a5d4a6,
    alias: ["/branch/yfh/bh-query/res/index.html","/branch/yfh/bh-query/res.html"],
    name: "branch-yfh-bh-query-res"
  }, {
    path: "/branch/yfh/inspection/query",
    component: _7d35d77c,
    alias: ["/branch/yfh/inspection/query/index.html","/branch/yfh/inspection/query.html"],
    name: "branch-yfh-inspection-query"
  }, {
    path: "/branch/yfh/news/detail",
    component: _0f616826,
    alias: ["/branch/yfh/news/detail/index.html","/branch/yfh/news/detail.html"],
    name: "branch-yfh-news-detail"
  }, {
    path: "/branch/yfh/news/newslist",
    component: _61b79e86,
    alias: ["/branch/yfh/news/newslist/index.html","/branch/yfh/news/newslist.html"],
    name: "branch-yfh-news-newslist"
  }, {
    path: "/branch/yfh/order/account",
    component: _71f7b3a1,
    alias: ["/branch/yfh/order/account/index.html","/branch/yfh/order/account.html"],
    name: "branch-yfh-order-account"
  }, {
    path: "/branch/yfh/order/detail",
    component: _46186ce6,
    alias: ["/branch/yfh/order/detail/index.html","/branch/yfh/order/detail.html"],
    name: "branch-yfh-order-detail"
  }, {
    path: "/branch/yfh/order/form",
    component: _34d47500,
    alias: ["/branch/yfh/order/form/index.html","/branch/yfh/order/form.html"],
    name: "branch-yfh-order-form"
  }, {
    path: "/branch/yfh/order/invoiceapply",
    component: _7527729d,
    alias: ["/branch/yfh/order/invoiceapply/index.html","/branch/yfh/order/invoiceapply.html"],
    name: "branch-yfh-order-invoiceapply"
  }, {
    path: "/branch/yfh/order/invoicedetail",
    component: _2163ec9c,
    alias: ["/branch/yfh/order/invoicedetail/index.html","/branch/yfh/order/invoicedetail.html"],
    name: "branch-yfh-order-invoicedetail"
  }, {
    path: "/branch/yfh/order/main",
    component: _6e4d8816,
    alias: ["/branch/yfh/order/main/index.html","/branch/yfh/order/main.html"],
    name: "branch-yfh-order-main"
  }, {
    path: "/branch/yfh/order/payment",
    component: _3af2720c,
    alias: ["/branch/yfh/order/payment/index.html","/branch/yfh/order/payment.html"],
    name: "branch-yfh-order-payment"
  }, {
    path: "/branch/yfh/order/refunddetail",
    component: _4c1dc805,
    alias: ["/branch/yfh/order/refunddetail/index.html","/branch/yfh/order/refunddetail.html"],
    name: "branch-yfh-order-refunddetail"
  }, {
    path: "/branch/yfh/order/xzchjg",
    component: _abd87bc0,
    alias: ["/branch/yfh/order/xzchjg/index.html","/branch/yfh/order/xzchjg.html"],
    name: "branch-yfh-order-xzchjg"
  }, {
    path: "/sys/ggzy/virtual-money-acc/detail",
    component: _7a18a4be,
    alias: ["/sys/ggzy/virtual-money-acc/detail/index.html","/sys/ggzy/virtual-money-acc/detail.html"],
    name: "sys-ggzy-virtual-money-acc-detail"
  }, {
    path: "/sys/ggzy/virtual-money-acc/list",
    component: _083a406a,
    alias: ["/sys/ggzy/virtual-money-acc/list/index.html","/sys/ggzy/virtual-money-acc/list.html"],
    name: "sys-ggzy-virtual-money-acc-list"
  }, {
    path: "/sys/ggzy/zb-file/detail",
    component: _9785ed66,
    alias: ["/sys/ggzy/zb-file/detail/index.html","/sys/ggzy/zb-file/detail.html"],
    name: "sys-ggzy-zb-file-detail"
  }, {
    path: "/sys/ggzy/zb-file/list",
    component: _c4b5c7cc,
    alias: ["/sys/ggzy/zb-file/list/index.html","/sys/ggzy/zb-file/list.html"],
    name: "sys-ggzy-zb-file-list"
  }, {
    path: "/sys/ggzy/zb-notice/detail",
    component: _6601b2ae,
    alias: ["/sys/ggzy/zb-notice/detail/index.html","/sys/ggzy/zb-notice/detail.html"],
    name: "sys-ggzy-zb-notice-detail"
  }, {
    path: "/sys/ggzy/zb-notice/form",
    component: _f8648cc8,
    alias: ["/sys/ggzy/zb-notice/form/index.html","/sys/ggzy/zb-notice/form.html"],
    name: "sys-ggzy-zb-notice-form"
  }, {
    path: "/sys/ggzy/zb-notice/form-fast-add",
    component: _4027571e,
    alias: ["/sys/ggzy/zb-notice/form-fast-add/index.html","/sys/ggzy/zb-notice/form-fast-add.html"],
    name: "sys-ggzy-zb-notice-form-fast-add"
  }, {
    path: "/sys/ggzy/zb-notice/list",
    component: _90723f14,
    alias: ["/sys/ggzy/zb-notice/list/index.html","/sys/ggzy/zb-notice/list.html"],
    name: "sys-ggzy-zb-notice-list"
  }, {
    path: "/sys/ggzy/zb-pro/list",
    component: _5617a18a,
    alias: ["/sys/ggzy/zb-pro/list/index.html","/sys/ggzy/zb-pro/list.html"],
    name: "sys-ggzy-zb-pro-list"
  }, {
    path: "/sys/ggzy/zb-pro/list-bd",
    component: _53f654c4,
    alias: ["/sys/ggzy/zb-pro/list-bd/index.html","/sys/ggzy/zb-pro/list-bd.html"],
    name: "sys-ggzy-zb-pro-list-bd"
  }, {
    path: "/sys/guarantee/hanhua/hhly-apply",
    component: _191bbdaf,
    alias: ["/sys/guarantee/hanhua/hhly-apply/index.html","/sys/guarantee/hanhua/hhly-apply.html"],
    name: "sys-guarantee-hanhua-hhly-apply"
  }, {
    path: "/web/guarantee/hanhua/form",
    component: _437cd2de,
    alias: ["/web/guarantee/hanhua/form/index.html","/web/guarantee/hanhua/form.html"],
    name: "web-guarantee-hanhua-form"
  }, {
    path: "/web/guarantee/hanhua/hhly-apply",
    component: _5d16ebc8,
    alias: ["/web/guarantee/hanhua/hhly-apply/index.html","/web/guarantee/hanhua/hhly-apply.html"],
    name: "web-guarantee-hanhua-hhly-apply"
  }, {
    path: "/web/guarantee/huanghe/form",
    component: _2e3b4cba,
    alias: ["/web/guarantee/huanghe/form/index.html","/web/guarantee/huanghe/form.html"],
    name: "web-guarantee-huanghe-form"
  }, {
    path: "/web/guarantee/tianan/form",
    component: _8c8cc4a4,
    alias: ["/web/guarantee/tianan/form/index.html","/web/guarantee/tianan/form.html"],
    name: "web-guarantee-tianan-form"
  }, {
    path: "/web/guarantee/yangguang/form",
    component: _d5012c78,
    alias: ["/web/guarantee/yangguang/form/index.html","/web/guarantee/yangguang/form.html"],
    name: "web-guarantee-yangguang-form"
  }, {
    path: "/web/guarantee/zhonghua/form-xm",
    component: _065557ce,
    alias: ["/web/guarantee/zhonghua/form-xm/index.html","/web/guarantee/zhonghua/form-xm.html"],
    name: "web-guarantee-zhonghua-form-xm"
  }, {
    path: "/branch/bhtong/aboutus/sectioins/company-introduction",
    component: _2cc02207,
    alias: ["/branch/bhtong/aboutus/sectioins/company-introduction/index.html","/branch/bhtong/aboutus/sectioins/company-introduction.html"],
    name: "branch-bhtong-aboutus-sectioins-company-introduction"
  }, {
    path: "/branch/bhtong/aboutus/sectioins/platform-introduction",
    component: _bc628132,
    alias: ["/branch/bhtong/aboutus/sectioins/platform-introduction/index.html","/branch/bhtong/aboutus/sectioins/platform-introduction.html"],
    name: "branch-bhtong-aboutus-sectioins-platform-introduction"
  }, {
    path: "/branch/bhtong/aboutus/sectioins/statistic-box",
    component: _38074a01,
    alias: ["/branch/bhtong/aboutus/sectioins/statistic-box/index.html","/branch/bhtong/aboutus/sectioins/statistic-box.html"],
    name: "branch-bhtong-aboutus-sectioins-statistic-box"
  }, {
    path: "/web/guarantee/tianan/text/text",
    component: _569b8e8b,
    alias: ["/web/guarantee/tianan/text/text/index.html","/web/guarantee/tianan/text/text.html"],
    name: "web-guarantee-tianan-text-text"
  }, {
    path: "/",
    component: _547b727b,
    alias: ["/index.html"],
    name: "index"
  }, {
    path: "*",
    component: _726bf2bf,
    name: "404"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
